import { render, staticRenderFns } from "./lrValueToLabel.vue?vue&type=template&id=64694586&"
import script from "./lrValueToLabel.vue?vue&type=script&lang=js&"
export * from "./lrValueToLabel.vue?vue&type=script&lang=js&"
import style0 from "./lrValueToLabel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports